import { render, staticRenderFns } from "./AnimationFrame.vue?vue&type=template&id=06e7f660&scoped=true"
import script from "./AnimationFrame.vue?vue&type=script&lang=js"
export * from "./AnimationFrame.vue?vue&type=script&lang=js"
import style0 from "./AnimationFrame.vue?vue&type=style&index=0&id=06e7f660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7f660",
  null
  
)

export default component.exports